//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

export enum GraphApiUserInsightsPeriod {
  Day = 'Day',
  Week = 'Week',
  Lifetime = 'Lifetime',
}
